<template>
  <div class="flex flex-col items-center justify-center space-y-3">
    <svg class="w-10 h-10 animate-spin text-gray-300" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="40" stroke="currentColor" stroke-width="8" class="opacity-25" />
      <path d="M50 10a40 40 0 0 1 40 40" stroke="#000000" stroke-width="8" stroke-linecap="round" class="opacity-75" />
    </svg>
    <span v-if="text" class="text-sm font-medium text-gray-500 tracking-wide">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "LoaderComponent",
  props: {
    text: {
      type: String,
      default: ""
    }
  }
}
</script>